import { __decorate } from "tslib";
import RenderField from '@/components/Builder/RenderField.vue';
import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator';
let Renderer = class Renderer extends Vue {
    fields;
    value;
    data = {};
    created() {
        this.data = this.value || {};
    }
    onDataChanged(newData) {
        return newData;
    }
    shouldBeFieldRendered(field) {
        if (!field.dependsOn)
            return true;
        return this.data[field.dependsOn] === field.dependerValue;
    }
};
__decorate([
    Prop({ type: Array, required: true })
], Renderer.prototype, "fields", void 0);
__decorate([
    Model('input')
], Renderer.prototype, "value", void 0);
__decorate([
    Watch('data', { deep: true }),
    Emit('input')
], Renderer.prototype, "onDataChanged", null);
Renderer = __decorate([
    Component({
        components: {
            RenderField
        },
    })
], Renderer);
export default Renderer;
